import React from 'react';

export const defaultBaseColor = '#eee';

export const defaultHighlightColor = '#f5f5f5';

export interface SkeletonProps {
  style?: React.CSSProperties;
  animation?: 'wave' | 'pulse';
}

export default function Skeleton({ style = {}, animation = 'wave' }: SkeletonProps) {
  return (
    <span
      className={`skeleton skeleton_${animation}`}
      style={{
        ...style
      }}
    >
      &zwnj;
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Skeleton.js